// ══════════════════════════════════════════════════════════════════════════════════════════════
//  t319 · ¿ESTÁ ABIERTO EL PANEL DE LA AYUDA? — Y DÓNDE VAN ENTONCES LOS AVISOS DEL CHAT
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  EL FALLO (20-oct-2026). En el móvil (390 px), el panel de la ayuda (components/ChatWidget, el globo de abajo a la
//  derecha) ocupa casi toda la pantalla, y los dos avisos del chat del equipo salen arriba a la derecha, debajo de la
//  cabecera: justo donde el panel tiene su cabecera, su aspa y el buscador.
//   · El aviso de un mensaje nuevo (components/ChatNotifFlotante, capa 2500) va ENCIMA del panel (2000): tapaba el aspa
//     y el buscador.
//   · El aviso fijo de una mención (components/CampanaAvisos, B-160) vive dentro de la barra de arriba (capa 30), así que
//     el panel lo tapaba a él: se veía una tira cortada y, en un móvil bajo, nada.
//
//  EL ARREGLO. Los dos avisos preguntan aquí si el panel está abierto:
//   · cerrado → 'arriba': donde siempre;
//   · abierto en su sitio → 'pastilla': el aviso se pliega en una pastilla de 52 px abajo, a la izquierda del globo,
//     en la franja que el panel deja libre debajo de él (el panel empieza a 86 px del borde de abajo y el globo ocupa
//     16-68 px en la columna de la derecha). Ni el panel tapa el aviso ni el aviso tapa el panel;
//   · a pantalla completa → 'oculto': no queda ningún hueco libre; el aviso no se pinta mientras dure (como dentro del
//     chat) y vuelve al reducir o cerrar el panel. No es «irse con el tiempo»: lo decide lo que hay en pantalla.
//
//  POR QUÉ UN MÓDULO Y NO UN EVENTO: quien se monta después (la campana tras volver de otra pantalla) tiene que saber
//  CÓMO ESTÁ el panel, no solo enterarse de cuándo cambia. Cada panel avisa con su nombre (la ayuda de la clínica y la
//  burbuja del soporte de Biango dentro de una clínica): con uno abierto basta.
//
//  Sin imports a propósito: las guardias lo cargan de verdad (test-helpers/utilDelFrontend) y lo comparten la campana,
//  el aviso del chat y el panel montados en la misma prueba. Lo mide backend/routes/avisos-chat-no-tapan-la-ayuda.test.js.

const paneles = {}
const oyentes = new Set()
let estado = { abierto: false, ampliado: false }

// Lo que hay ahora: abierto si alguno lo está; a pantalla completa si alguno abierto lo está.
export function estadoPanelAyuda() { return estado }

// Lo llama cada panel al abrirse, cerrarse, ampliarse o reducirse (y al desmontarse, cerrado).
export function avisarPanelAyuda(nombre, { abierto = false, ampliado = false } = {}) {
  paneles[String(nombre || 'ayuda')] = { abierto: !!abierto, ampliado: !!(abierto && ampliado) }
  const lista = Object.values(paneles)
  const nuevo = { abierto: lista.some((p) => p.abierto), ampliado: lista.some((p) => p.ampliado) }
  if (nuevo.abierto === estado.abierto && nuevo.ampliado === estado.ampliado) return
  estado = nuevo
  for (const f of Array.from(oyentes)) { try { f(estado) } catch (_) { /* un oyente roto no para a los demás */ } }
}

// Devuelve con qué darse de baja (para el `return` de un useEffect).
export function suscribirPanelAyuda(f) {
  oyentes.add(f)
  return () => { oyentes.delete(f) }
}

// 'arriba' | 'pastilla' | 'oculto' (ver arriba).
export function sitioDeLosAvisos(e = estado) {
  if (!e || !e.abierto) return 'arriba'
  return e.ampliado ? 'oculto' : 'pastilla'
}

// LA PASTILLA, una para los dos avisos: abajo, a la izquierda del globo de la ayuda (52 px a 16 del borde) con 12 px de
// aire, y del mismo alto que el globo, así que acaba a 68 px del borde: por debajo de los 86 a los que empieza el panel.
// La zona segura de abajo (la barra del sistema) se suma igual que en el globo y el panel; el ancho se divide por el
// zoom del perfil (var(--z), utils/uiScale) como cualquier medida de la ventana.
export const PASTILLA_AVISO = {
  top: 'auto',
  bottom: 'calc(16px + var(--sa-abajo))',
  right: '80px',
  width: 'min(330px, calc((100vw / var(--z, 1)) - 96px))',
  height: '52px',
  boxSizing: 'border-box',
}
